export const ROLE_BACKHAUL_READ = 'backhaul:read';
export const ROLE_BACKHAUL_WRITE = 'backhaul:write';
export const ROLE_PUBLIC_WIFI_READ = 'public_wifi:read';
export const ROLE_PUBLIC_WIFI_WRITE = 'public_wifi:write';
export const ROLE_DEVICE_CONFIG_WRITE = 'device_config:write';

export const USER_TYPE_ADMIN = 'admin';
export const USER_TYPE_REGULAR = 'regular';
export const USER_TYPE_VIEWER = 'viewer';
